<!-- 回收商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "createTimeFrom": "20210608000000",
                "createTimeTo": "20210608235959",
                "pageNum":"1",
                "pageSize":"10"
                },
            responseCode: {
                "data": {
                    "recordList": [
                        {
                            "account": "13812345678",
                            "address": "",
                            "carrierId": 6,
                            "contact": "test",
                            "createTime": "20210507175631",
                            "expiredRefundNum": 0,
                            "grantNum": 1,
                            "parkCode": "test",
                            "phone": "13812345678",
                            "refundNum": 0,
                            "remainNum": 25,
                            "sellNum": 26,
                            "status": 1,
                            "supportFixedQr": 0,
                            "traderCode": "test",
                            "traderId": 1,
                            "traderName": "主流程测试1",
                            "useNum": 0
                        }
                    ],
                    "total": 31
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            }
,
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询商家列表",
                t_url: this.commonUrls.test+"getTraderList",
                p_url: this.commonUrls.prod+"getTraderList",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        // { info1: 'parkCodeList', info2: '否', info3: 'String[]', info4: '停车场编号列表，带此值时仅返回绑定了这些车场的' },
                        { info1: 'createTimeFrom', info2: '是', info3: 'String', info4: '添加时间起始时间，yyyyMMddHHmmss' },
                        { info1: 'createTimeTo', info2: '是', info3: 'String', info4: '添加时间结束时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'account', info2: '是', info3: 'String', info4: '账号' },
                        { info1: 'address', info2: '否', info3: 'String', info4: '地址' },
                        { info1: 'carrierId', info2: '否', info3: 'Long', info4: '运营商ID' },
                        { info1: 'contact', info2: '是', info3: 'String', info4: '联系人' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '添加时间，yyyyMMddHHmmss' },
                        { info1: 'expiredRefundNum', info2: '是', info3: 'Integer', info4: '预期回收数量' },
                        { info1: 'grantNum', info2: '是', info3: 'Integer', info4: '已发放数量' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '所属车场' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '手机号码' },
                        { info1: 'refundNum', info2: '否', info3: 'Integer', info4: '累计已退（张）' },
                        { info1: 'remainNum', info2: '否', info3: 'Integer', info4: '剩余券数量' },
                        { info1: 'sellNum', info2: '否', info3: 'Integer', info4: '累计已购买券数量（张）' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '状态：0冻结；1启用' },
                        { info1: 'supportFixedQr', info2: '否', info3: 'Integer', info4: '是否支持固定码发券：0否1是' },
                        { info1: 'traderCode', info2: '否', info3: 'String', info4: '商家代码' },
                        { info1: 'traderId', info2: '否', info3: 'Long', info4: '商家ID' },
                        { info1: 'traderName', info2: '否', info3: 'String', info4: '商家名称' },
                        { info1: 'useNum', info2: '否', info3: 'Integer', info4: '累计被使用券数量' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/getTraderList.vue